import { message } from 'antd'
import {
  REQUESTING_TEMP_TOKEN,
  TEMP_TOKEN_SUCCESS,
  TEMP_TOKEN_ERROR,

  LOGIN_PENDING,
  LOGIN_SUCCESS,
  LOGIN_ERROR,

  LOGOUT_PENDING,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,

  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_ERROR,

  REGISTER_PENDING,
  REGISTER_SUCCESS,
  REGISTER_ERROR,

  RESEND_VERIFICATION_EMAIL_PENDING,
  RESEND_VERIFICATION_EMAIL_SUCCESS,
  RESEND_VERIFICATION_EMAIL_ERROR,

  EDIT_CURRENT_USER,

  CHANGE_SLACK_SIDEBAR,
  CHANGE_SLACK_POPUP,

  NAV, REFRESH_RM
} from '../actions/auth';

const initialState = {
  user: null,
  loggingIn: false,
  loggingOut: false,
  loginErrors: null,
  error: null,
  slack_on_sidebar : false,
  slack_on_popup   : false,
  REFRESH_RM: false,
  success : false,
}

export default function auth(state = initialState, action = {}) {
  switch (action.type) {

    case REQUESTING_TEMP_TOKEN:
    case TEMP_TOKEN_SUCCESS:
    case TEMP_TOKEN_ERROR:

    case LOGIN_PENDING:
      return Object.assign({}, initialState, { loggingIn: true, loading:true,
        REFRESH_RM: false })

    
    case LOGIN_SUCCESS:
      let token = (action||{}).data;
      console.log(token);
      
      // localStorage.setItem('user', JSON.stringify(user));
      
      localStorage.setItem('Authorization', 'Bearer ' + token);
      return Object.assign({}, state, { user: "user" ,loggingIn: false, loginErrors: null, loading:false, REFRESH_RM: false })

    case LOGIN_ERROR:
      return {
        ...state,
        loggingIn: false,
        loading :false,
        user: null,
        loginErrors: action.message,
        REFRESH_RM: false
      }

    case LOGOUT_PENDING:
    case LOGOUT_SUCCESS:
    case LOGOUT_ERROR:
      localStorage.clear();
      return {
        ...state,
        loggingOut: false,
        user: null,
        loginErrors: null,
        REFRESH_RM: false
      }

    case FETCH_PROFILE_SUCCESS:
      localStorage.setItem('user', JSON.stringify((action||{}).data))
      return Object.assign({}, state, { user: (action||{}).data, loggingIn: false, loginErrors: null,
        REFRESH_RM: false })

    case FETCH_PROFILE_ERROR:
      return Object.assign({}, state, { user: null, loggingIn: false, loginErrors: null,
        REFRESH_RM: false });

    case RESEND_VERIFICATION_EMAIL_PENDING:
    case REGISTER_PENDING:
      return Object.assign({}, initialState, state, { busy: true,
        REFRESH_RM: false });

    case REGISTER_SUCCESS:
      const { email, message: result } = (action||{}).data
      message.success(result)
      return { ...state, busy: false, success:true, user: { email },
        REFRESH_RM: false }

    case REGISTER_ERROR:
      message.error(action.message)
      return {
        ...state,
        busy: false,
        error: action.message,
        REFRESH_RM: false
      }

    case RESEND_VERIFICATION_EMAIL_SUCCESS:
      message.success((action||{}).data.message)
      return {...state,
      REFRESH_RM: false}

    case RESEND_VERIFICATION_EMAIL_ERROR:
      message.error(action.message)
      return {...state,
        REFRESH_RM: false}

    case CHANGE_SLACK_SIDEBAR:
      state.user.slack_on_sidebar = action.checked
      return {...state, slack_on_sidebar : action.checked,
        REFRESH_RM: false}

    case CHANGE_SLACK_POPUP:
      state.user.slack_on_popup = action.checked
      return {...state, slack_on_popup : action.checked,
        REFRESH_RM: false}

    case EDIT_CURRENT_USER:
      return {
        ...state,
        user: {
          ...state.user,
          ...(action||{}).data,
          REFRESH_RM: false
        }
      }

    case NAV:
      return {
        ...state,
        nav: action.page,
        REFRESH_RM: false
      }
    case REFRESH_RM:
      return {
        ...state,
        REFRESH_RM: true
      }
    default:
      return {...state, REFRESH_RM: false}
  }
}
